import { render, staticRenderFns } from "./CadastroProcedimentoGrupo.vue?vue&type=template&id=68a47c02&"
import script from "./CadastroProcedimentoGrupo.vue?vue&type=script&lang=js&"
export * from "./CadastroProcedimentoGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports